import styled from 'styled-components';

export default styled.div`
  .tree_wrap {
    position: absolute;
    z-index: 1050;
    font-size: 14px;
    white-space: nowrap;
    background: #fff;
    border-radius: 2 px;
    box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
      0 9px 28px 8px rgb(0 0 0 / 5%);
    top: 34px;
    left: 0;
    padding-right: 12px;
  }
  .label-between {
    display: flex;
    justify-content: space-between;
  }
  .label-hover-hidden {
    display: none;
    font-size: 22px;
  }
  .label-between:hover {
    .label-hover-hidden {
      background: #ecf3fa;
      border-radius: 12px;
      color: #1565c0;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding: 0 8px;
      gap: 4px;
    }
  }
  .popover-overlay-style {
    .site-tree-search-value {
      color: #f50;
    }
  }
`;
